import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { isMasterByEmail } from '@/shared/utils/role'
import { getOpportunityPublishInfoMemberVisible } from '@/modules/settings/services/opportunityPublishInfoService'
import { format as formatUTC } from '@/shared/utils/date'
import { useUserDateFormatter } from '@/modules/auth/hooks/useUserTimezone'

export default function PublishedAtInfo({ publishedAt }: { publishedAt?: string | null }) {
  const { user, profile } = useAuth()
  const isMaster = isMasterByEmail(user?.email) || profile?.role === 'master'
  const [memberVisible, setMemberVisible] = React.useState<boolean | null>(null)
  const { formatUserDateTime, timezone } = useUserDateFormatter()

  React.useEffect(() => {
    let alive = true
    getOpportunityPublishInfoMemberVisible()
      .then((on) => { if (alive) setMemberVisible(!!on) })
      .catch(() => { if (alive) setMemberVisible(false) })
    return () => { alive = false }
  }, [])

  const allowed = isMaster ? true : !!memberVisible
  if (!publishedAt || !allowed) return null

  const localLabel = formatUserDateTime(publishedAt)
  const utcLabel = formatUTC(publishedAt)
  const tzSuffix = timezone && timezone !== 'Etc/UTC' ? ` (${timezone})` : ' (UTC)'

  return (
    <>
      <span>Publicado em</span>
      <span className="text-right" title={utcLabel}>
        {localLabel}
        {tzSuffix}
      </span>
    </>
  )
}
